/**
 * Huance Global Theme - Main JavaScript v2.0
 * B2B Auto Fastener Optimized
 */
(function() {
  'use strict';

  // ============================================
  // Promo Bar
  // ============================================
  function initPromoBar() {
    var promoBar = document.querySelector('.promo-bar');
    var closeBtn = document.getElementById('closePromoBar');
    var header = document.getElementById('siteHeader');
    if (!promoBar || !closeBtn) return;
    if (localStorage.getItem('promoBarClosed') === 'true') {
      promoBar.style.display = 'none';
      if (header) header.style.top = '0';
      document.body.style.paddingTop = '20px';
      return;
    }
    closeBtn.addEventListener('click', function() {
      promoBar.style.display = 'none';
      if (header) header.style.top = '0';
      document.body.style.paddingTop = '20px';
      localStorage.setItem('promoBarClosed', 'true');
    });
  }

  // ============================================
  // Hero Carousel — with autoplay, dots only
  // ============================================
  function initHeroCarousel() {
    var carousel = document.getElementById('heroCarousel');
    if (!carousel) return;
    var slides = carousel.querySelectorAll('.hero__slide');
    var dots = carousel.querySelectorAll('.hero__dot');
    if (slides.length <= 1) return;

    var currentSlide = 0;
    var autoplayInterval = null;

    function goToSlide(index) {
      // Remove animation from previous slide's text
      var prevSlideEl = slides[currentSlide];
      var prevTitle = prevSlideEl.querySelector('.hero__title');
      var prevDesc = prevSlideEl.querySelector('.hero__desc');
      if (prevTitle) {
        prevTitle.style.animation = 'none';
        prevTitle.style.opacity = '0';
      }
      if (prevDesc) {
        prevDesc.style.animation = 'none';
        prevDesc.style.opacity = '0';
      }

      slides[currentSlide].classList.remove('hero__slide--active');
      if (dots[currentSlide]) dots[currentSlide].classList.remove('hero__dot--active');
      currentSlide = (index + slides.length) % slides.length;
      slides[currentSlide].classList.add('hero__slide--active');
      if (dots[currentSlide]) dots[currentSlide].classList.add('hero__dot--active');

      // Re-trigger text and button animations for current slide
      var currentSlideEl = slides[currentSlide];
      var title = currentSlideEl.querySelector('.hero__title');
      var desc = currentSlideEl.querySelector('.hero__desc');
      var fixedBar = carousel.querySelector('.hero__fixed-bar');

      if (title) {
        title.style.opacity = '';
        title.style.animation = 'none';
        title.offsetHeight;
        title.style.animation = '';
      }
      if (desc) {
        desc.style.opacity = '';
        desc.style.animation = 'none';
        desc.offsetHeight;
        desc.style.animation = '';
      }
      if (fixedBar) {
        fixedBar.style.animation = 'none';
        fixedBar.offsetHeight;
        fixedBar.style.animation = '';
      }
    }

    function startAutoplay() {
      autoplayInterval = setInterval(function() {
        goToSlide(currentSlide + 1);
      }, 3000);
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    dots.forEach(function(dot, index) { dot.addEventListener('click', function() { stopAutoplay(); goToSlide(index); startAutoplay(); }); });
    addSwipeSupport(carousel, function() { stopAutoplay(); goToSlide(currentSlide + 1); startAutoplay(); }, function() { stopAutoplay(); goToSlide(currentSlide - 1); startAutoplay(); });

    // Start autoplay
    startAutoplay();

    // Pause on hover
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
  }

  // ============================================
  // Mobile Navigation
  // ============================================
  function initMobileNav() {
    var mobileNav = document.getElementById('mobileNav');
    var openBtn = document.getElementById('openMobileMenu');
    var openBtnHeader = document.getElementById('openMobileMenuBtn');
    var closeBtn = document.getElementById('closeMobileNavBtn');
    var overlay = document.getElementById('closeMobileNav');
    if (!mobileNav) return;

    function openMenu() { mobileNav.classList.add('mobile-nav--open'); mobileNav.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function closeMenu() { mobileNav.classList.remove('mobile-nav--open'); mobileNav.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

    if (openBtn) openBtn.addEventListener('click', openMenu);
    if (openBtnHeader) openBtnHeader.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    // Highlight active bottom bar button based on current page
    var bottomItems = document.querySelectorAll('.mobile-bottom-bar__item');
    var currentPath = window.location.pathname;

    function updateActiveButton() {
      bottomItems.forEach(function(item) {
        item.classList.remove('mobile-bottom-bar__item--active');
        var href = item.getAttribute('href');
        if (href && (currentPath === href || (href === '/' && currentPath === '/'))) {
          item.classList.add('mobile-bottom-bar__item--active');
        }
      });
    }
    updateActiveButton();

    // Click handler for bottom bar items
    bottomItems.forEach(function(item) {
      item.addEventListener('click', function() {
        bottomItems.forEach(function(i) { i.classList.remove('mobile-bottom-bar__item--active'); });
        this.classList.add('mobile-bottom-bar__item--active');
      });
    });

    if (overlay) overlay.addEventListener('click', closeMenu);

    var toggles = mobileNav.querySelectorAll('.mobile-nav__toggle');
    toggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var submenu = this.nextElementSibling;
        var isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !isExpanded);
        submenu.style.display = isExpanded ? 'none' : 'block';
        this.querySelector('svg').style.transform = isExpanded ? '' : 'rotate(180deg)';
      });
    });
  }

  // ============================================
  // Sticky Header
  // ============================================
  function initStickyNav() {
    var header = document.getElementById('siteHeader');
    if (!header || !header.classList.contains('site-header--sticky')) return;
    var lastScroll = 0;
    window.addEventListener('scroll', function() {
      var currentScroll = window.pageYOffset;
      if (currentScroll > 100) header.classList.add('site-header--scrolled');
      else header.classList.remove('site-header--scrolled');
      if (currentScroll > lastScroll && currentScroll > 200) header.classList.add('site-header--hidden');
      else header.classList.remove('site-header--hidden');
      lastScroll = currentScroll;
    });

    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="/#"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var targetId = this.getAttribute('href').replace('/#', '');
        var target = document.getElementById(targetId);

        if (target) {
          // If target exists on current page, smooth scroll to it
          var headerHeight = header.offsetHeight;
          var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
          window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        } else {
          // If target doesn't exist on current page (e.g., on product page), redirect to homepage
          window.location.href = this.getAttribute('href');
        }
      });
    });
  }

  // ============================================
  // Floating Sidebar
  // ============================================
  function initFloatingSidebar() {
    var backToTop = document.getElementById('backToTop');
    var quoteBtn = document.getElementById('openQuoteSidebar');
    if (backToTop) {
      window.addEventListener('scroll', function() { backToTop.style.display = window.pageYOffset > 500 ? 'flex' : 'none'; });
      backToTop.addEventListener('click', function() { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    }
    if (quoteBtn) {
      quoteBtn.addEventListener('click', function() {
        var quoteModal = document.getElementById('quoteModal');
        if (quoteModal) { quoteModal.classList.add('modal--active'); quoteModal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
      });
    }
  }

  // ============================================
  // Chat Popup — simplified
  // ============================================
  function initChatPopup() {
    var chatPopup = document.getElementById('chatPopup');
    var chatToggle = document.getElementById('chatToggle');
    var chatClose = document.getElementById('chatClose');
    if (!chatPopup || !chatToggle) return;
    chatToggle.addEventListener('click', function() { chatPopup.classList.toggle('chat-popup--open'); });
    if (chatClose) chatClose.addEventListener('click', function() { chatPopup.classList.remove('chat-popup--open'); });
    document.addEventListener('click', function(e) { if (!chatPopup.contains(e.target)) chatPopup.classList.remove('chat-popup--open'); });
  }

  // ============================================
  // Subscription Popup
  // ============================================
  function initSubscriptionPopup() {
    var popup = document.getElementById('subscribePopup');
    if (!popup) return;
    if (sessionStorage.getItem('subscribeShown') === 'true') return;
    var delay = parseInt(popup.dataset.delay || 15) * 1000;
    // Longer delay on mobile to avoid interfering with browsing
    if (window.innerWidth <= 768) delay = Math.max(delay, 30000);
    setTimeout(function() {
      popup.classList.add('modal--active');
      popup.setAttribute('aria-hidden', 'false');
      sessionStorage.setItem('subscribeShown', 'true');
    }, delay);
    var closeBtns = popup.querySelectorAll('[data-close-subscribe]');
    closeBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        popup.classList.remove('modal--active'); popup.setAttribute('aria-hidden', 'true');
      });
    });
    var form = popup.querySelector('form');
    if (form) form.addEventListener('submit', function() {
      popup.classList.remove('modal--active'); popup.setAttribute('aria-hidden', 'true');
    });
  }

  // ============================================
  // Quote Modal
  // ============================================
  function initQuoteModal() {
    var modal = document.getElementById('quoteModal');
    if (!modal) return;
    var openBtns = document.querySelectorAll('[data-open-quote]');
    openBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        modal.classList.add('modal--active'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
      });
    });
    var closeBtns = modal.querySelectorAll('[data-close-modal]');
    closeBtns.forEach(function(btn) {
      btn.addEventListener('click', function() { modal.classList.remove('modal--active'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; });
    });
    var overlay = modal.querySelector('.modal__overlay');
    if (overlay) overlay.addEventListener('click', function() { modal.classList.remove('modal--active'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && modal.classList.contains('modal--active')) { modal.classList.remove('modal--active'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } });
  }

  // ============================================
  // Search Form Enhancement
  // ============================================
  function initSearchForm() {
    var form = document.getElementById('oemSearchForm');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      var input = form.querySelector('input[name="q"]');
      var brand = form.querySelector('select[name="vehicle_brand"]');
      if (brand && brand.value) {
        var brandTag = 'vehicle:' + brand.value;
        if (input.value.indexOf(brandTag) === -1) input.value = input.value + ' ' + brandTag;
      }
    });
  }

  // ============================================
  // Reviews Carousel — infinite auto-scroll via CSS
  // ============================================
  function initReviewsCarousel() {
    var container = document.getElementById('reviewsScroll');
    if (!container) return;
    var track = container.querySelector('.reviews__track');
    if (!track) return;

    // Clone cards for seamless loop
    var cards = track.querySelectorAll('.reviews__card');
    cards.forEach(function(card) {
      var clone = card.cloneNode(true);
      track.appendChild(clone);
    });
  }

  // ============================================
  // Kits Carousel — infinite auto-scroll via CSS
  // ============================================
  // Counter Animation
  // ============================================
  function initCounters() {
    var counters = document.querySelectorAll('[data-count]');
    if (!counters.length) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var target = parseInt(entry.target.dataset.count);
          var el = entry.target;
          var current = 0;
          var increment = target / 50;
          var timer = setInterval(function() {
            current += increment;
            if (current >= target) { current = target; clearInterval(timer); }
            if (el.dataset.count === '99') el.textContent = Math.floor(current) + '%';
            else el.textContent = Math.floor(current).toLocaleString() + '+';
          }, 40);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(function(counter) { observer.observe(counter); });
  }

  // ============================================
  // Currency Switcher (Product Page)
  // ============================================
  function initCurrencySwitcher() {
    var switcher = document.getElementById('currencySwitcher');
    if (!switcher) return;
    var options = switcher.querySelectorAll('.product-detail__currency-option');
    var currentLabel = document.getElementById('currentCurrency');
    options.forEach(function(opt) {
      opt.addEventListener('click', function(e) {
        e.preventDefault();
        options.forEach(function(o) { o.classList.remove('active'); });
        this.classList.add('active');
        if (currentLabel) currentLabel.textContent = this.dataset.currency;
      });
    });
  }

  // ============================================
  // Shopify Cart System (AJAX)
  // ============================================
  function initCart() {
    // Fetch current cart count on page load
    fetchCartCount();

    // Handle Add to Cart and Buy Now buttons with data-product attribute
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-product]');
      if (!btn || !btn.dataset.price) return;
      e.preventDefault();

      var variantId = btn.dataset.product;
      var isBuyNow = btn.classList.contains('btn--outline');
      var originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      // Use Shopify AJAX API to add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (isBuyNow) {
          // Buy Now: redirect to checkout
          window.location.href = '/checkout';
        } else {
          // Add to Cart: show success feedback
          btn.textContent = 'Added ✓';
          btn.style.backgroundColor = '#28A745';
          btn.style.borderColor = '#28A745';
          fetchCartCount();
          setTimeout(function() {
            btn.textContent = originalText;
            btn.style.backgroundColor = '';
            btn.style.borderColor = '';
            btn.disabled = false;
          }, 1500);
        }
      })
      .catch(function(err) {
        btn.textContent = 'Error';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      });
    });
  }

  function fetchCartCount() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var el = document.getElementById('cartCount');
        if (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      });
  }

  // ============================================
  // Touch Swipe for Carousels
  // ============================================
  function addSwipeSupport(container, onSwipeLeft, onSwipeRight) {
    if (!container) return;
    var startX = 0, startY = 0, diffX = 0;
    container.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    container.addEventListener('touchmove', function(e) {
      diffX = e.touches[0].clientX - startX;
      var diffY = e.touches[0].clientY - startY;
      // Only horizontal swipe — let vertical scroll through
      if (Math.abs(diffX) > Math.abs(diffY)) e.preventDefault();
    }, { passive: false });
    container.addEventListener('touchend', function() {
      if (Math.abs(diffX) > 50) {
        if (diffX < 0) onSwipeLeft();
        else onSwipeRight();
      }
      diffX = 0;
    }, { passive: true });
  }

  // ============================================
  // Category Filter (Best Selling Products)
  // ============================================
  function initCategoryFilter() {
    var catBtns = document.querySelectorAll('.hot-products__cat-btn');
    var tableRows = document.querySelectorAll('.hot-products__table tbody tr');
    var mobileCards = document.querySelectorAll('.hot-products__mobile-card');
    var viewAllBtn = document.getElementById('viewAllProductsBtn');
    var customQuote = document.getElementById('customQuoteBlock');
    var tableWrap = document.querySelector('.hot-products__table-wrap');
    var mobileCardsWrap = document.querySelector('.hot-products__mobile-cards');
    var wholesaleNote = document.querySelector('.hot-products__wholesale-note');
    if (!catBtns.length) return;

    // Row click to product detail (desktop)
    tableRows.forEach(function(row) {
      row.addEventListener('click', function(e) {
        if (e.target.closest('.hot-products__actions')) return;
        var url = this.dataset.productUrl;
        if (url) window.location.href = url;
      });
    });

    catBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var category = this.dataset.category;
        // Update active button
        catBtns.forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');

        // Handle Custom Parts special case
        if (category === 'custom') {
          if (tableWrap) tableWrap.style.display = 'none';
          if (mobileCardsWrap) mobileCardsWrap.style.display = 'none';
          if (wholesaleNote) wholesaleNote.style.display = 'none';
          if (customQuote) customQuote.style.display = 'block';
          return;
        } else {
          if (tableWrap) tableWrap.style.display = '';
          if (mobileCardsWrap) mobileCardsWrap.style.display = '';
          if (wholesaleNote) wholesaleNote.style.display = '';
          if (customQuote) customQuote.style.display = 'none';
        }

        // Filter desktop table rows
        tableRows.forEach(function(row) {
          if (category === 'all' || row.dataset.category === category) {
            row.classList.remove('hidden');
          } else {
            row.classList.add('hidden');
          }
        });

        // Filter mobile cards
        mobileCards.forEach(function(card) {
          if (category === 'all' || card.dataset.category === category) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
        // Update View All Products link
        if (viewAllBtn) {
          if (category === 'all') {
            viewAllBtn.href = '/collections/all';
          } else {
            viewAllBtn.href = '/collections/' + category;
          }
        }
      });
    });
  }

  // ============================================
  // Currency Switcher with Real-time Exchange Rate
  // ============================================
  function initGlobalCurrency() {
    var priceElements = document.querySelectorAll('.hot-products__price-retail, .hot-products__mobile-card-price');
    var currencyBtn = document.getElementById('currencyBtn');
    var currencyMenu = document.getElementById('currencyMenu');
    var currencyOptions = document.querySelectorAll('.hot-products__currency-option');
    var currentCurrency = 'USD';
    var exchangeRates = null;

    if (!currencyBtn || !currencyMenu) return;

    // Fetch exchange rates from API
    function fetchExchangeRates() {
      fetch('https://open.er-api.com/v6/latest/USD')
        .then(function(response) { return response.json(); })
        .then(function(data) {
          if (data && data.rates) {
            exchangeRates = data.rates;
            updatePrices(currentCurrency);
          }
        })
        .catch(function(error) {
          console.warn('Failed to fetch exchange rates:', error);
          // Fallback rates
          exchangeRates = { USD: 1, EUR: 0.92, RUB: 89.50 };
          updatePrices(currentCurrency);
        });
    }

    // Toggle dropdown
    currencyBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      currencyMenu.classList.toggle('show');
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function() {
      currencyMenu.classList.remove('show');
    });

    // Currency option click
    currencyOptions.forEach(function(option) {
      option.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        currentCurrency = this.dataset.currency;
        // Update button text
        var symbol = getSymbol(currentCurrency);
        currencyBtn.textContent = symbol + ' ' + currentCurrency + ' ▾';
        // Update active state
        currencyOptions.forEach(function(opt) { opt.classList.remove('active'); });
        this.classList.add('active');
        // Update prices
        updatePrices(currentCurrency);
        // Close dropdown
        currencyMenu.classList.remove('show');
      });
    });

    function getSymbol(currency) {
      var symbols = { USD: '$', EUR: '€', GBP: '£', RUB: '₽', CAD: 'C$', AUD: 'A$', BRL: 'R$' };
      return symbols[currency] || '$';
    }

    function updatePrices(currency) {
      if (!exchangeRates) return;
      priceElements.forEach(function(el) {
        var usdPrice = parseFloat(el.dataset.priceUsd);
        if (isNaN(usdPrice)) return;
        var convertedPrice = usdPrice * (exchangeRates[currency] || 1);
        var symbol = getSymbol(currency);
        var prefix = currency === 'USD' ? '' : '≈ ';
        el.textContent = prefix + symbol + convertedPrice.toFixed(2);
      });
    }

    // Mobile currency buttons
    var mobileCurrencyBtns = document.querySelectorAll('.hot-products__mobile-currency-btn');
    mobileCurrencyBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        currentCurrency = this.dataset.currency;
        // Update active state
        mobileCurrencyBtns.forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
        // Update prices
        updatePrices(currentCurrency);
      });
    });

    // Initialize
    fetchExchangeRates();
  }

  // ============================================
  // Recent Purchase Popup — Social Proof
  // ============================================
  function initRecentPurchasePopup() {
    var popup = document.getElementById('recentPurchasePopup');
    if (!popup) return;

    var buyers = [
      { name: 'Someone in Russia', product: 'Wheel Hub Bolt Set', time: '2' },
      { name: 'A buyer in Brazil', product: 'Wheel Lug Nut Kit', time: '5' },
      { name: 'Someone in Germany', product: 'Brake Caliper Bolt', time: '8' },
      { name: 'A customer in UAE', product: 'Chassis Flange Nut', time: '12' },
      { name: 'Someone in Australia', product: 'Alloy Wheel Nut Set', time: '15' },
      { name: 'A buyer in Mexico', product: 'Wheel Hub Flange Bolt', time: '18' },
      { name: 'Someone in Turkey', product: 'Truck Chassis Fastener Kit', time: '22' },
      { name: 'A customer in India', product: 'Wheel Hub Bolt Set', time: '25' }
    ];

    var buyerEl = document.getElementById('purchaseBuyer');
    var productEl = document.getElementById('purchaseProduct');
    var timeEl = document.getElementById('purchaseTime');
    var closeBtn = document.getElementById('closePurchasePopup');
    var currentIndex = 0;

    function showPopup() {
      var buyer = buyers[currentIndex];
      buyerEl.textContent = buyer.name;
      productEl.textContent = buyer.product;
      timeEl.textContent = buyer.time + 'min ago ordered';
      popup.classList.add('show');
      currentIndex = (currentIndex + 1) % buyers.length;
    }

    function hidePopup() {
      popup.classList.remove('show');
    }

    // Show first popup after 5 seconds
    setTimeout(showPopup, 5000);

    // Auto hide after 6 seconds
    setInterval(function() {
      hidePopup();
      // Show next popup after 15 seconds
      setTimeout(showPopup, 15000);
    }, 21000);

    // Close button
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        hidePopup();
      });
    }

    // Click to close
    popup.addEventListener('click', hidePopup);
  }

  // ============================================
  // Car Model Selector — Mobile
  // ============================================
  function initCarModelSelector() {
    var brandSelect = document.getElementById('carBrand');
    var modelSelect = document.getElementById('carModel');
    var findPartsBtn = document.getElementById('findPartsBtn');
    if (!brandSelect || !modelSelect) return;

    var carModels = {
      toyota: ['Camry', 'Corolla', 'RAV4', 'Highlander', 'Tacoma', 'Tundra', 'Land Cruiser', 'Prius'],
      honda: ['Civic', 'Accord', 'CR-V', 'Pilot', 'Odyssey', 'HR-V', 'Fit'],
      bmw: ['3 Series', '5 Series', '7 Series', 'X3', 'X5', 'X7', 'M3', 'M5'],
      mercedes: ['C-Class', 'E-Class', 'S-Class', 'GLC', 'GLE', 'GLS', 'AMG GT'],
      ford: ['F-150', 'Mustang', 'Explorer', 'Escape', 'Edge', 'Bronco', 'Ranger'],
      vw: ['Golf', 'Jetta', 'Passat', 'Tiguan', 'Atlas', 'Audi A4', 'Audi Q5'],
      hyundai: ['Elantra', 'Sonata', 'Tucson', 'Santa Fe', 'Kia Forte', 'Kia Sportage'],
      nissan: ['Altima', 'Sentra', 'Rogue', 'Pathfinder', 'Frontier', 'Maxima']
    };

    brandSelect.addEventListener('change', function() {
      var brand = this.value;
      modelSelect.innerHTML = '<option value="">Select Model</option>';
      if (brand && carModels[brand]) {
        carModels[brand].forEach(function(model) {
          var option = document.createElement('option');
          option.value = model.toLowerCase().replace(/\s+/g, '-');
          option.textContent = model;
          modelSelect.appendChild(option);
        });
      }
    });

    // Filter products when brand changes
    brandSelect.addEventListener('change', function() {
      var brand = this.value;
      var mobileCards = document.querySelectorAll('.hot-products__mobile-card');
      if (!brand) {
        // Show all cards
        mobileCards.forEach(function(card) {
          card.style.display = '';
        });
        return;
      }
      // Filter cards by brand
      mobileCards.forEach(function(card) {
        var cardBrands = (card.dataset.brand || '').split(',');
        if (cardBrands.indexOf(brand) !== -1) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });

    if (findPartsBtn) {
      findPartsBtn.addEventListener('click', function() {
        var brand = brandSelect.value;
        var model = modelSelect.value;
        if (brand && model) {
          window.location.href = '/search?type=product&q=' + encodeURIComponent(brand + ' ' + model);
        } else if (brand) {
          // Already filtered, scroll to products
          document.getElementById('products').scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  }

  // ============================================
  // Random Viewer Count — Social Proof
  // ============================================
  function initRandomViewers() {
    var viewerElements = document.querySelectorAll('.hot-products__mobile-card-viewers');
    viewerElements.forEach(function(el) {
      var randomCount = Math.floor(Math.random() * 15) + 5; // 5-19 random viewers
      el.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 40 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle></svg> ' + randomCount + ' people viewing';
    });
  }

  // ============================================
  // Initialize All
  // ============================================
  function init() {
    initPromoBar();
    initHeroCarousel();
    initMobileNav();
    initStickyNav();
    initFloatingSidebar();
    initChatPopup();
    initSubscriptionPopup();
    initQuoteModal();
    initSearchForm();
    initReviewsCarousel();
    initCounters();
    initCurrencySwitcher();
    initRecentPurchasePopup();
    initCarModelSelector();
    initCategoryFilter();
    initGlobalCurrency();
    initCart();
    initRandomViewers();
    initNavProductCounts();
  }

  // ============================================
  // Navigation Product Counts (via JSON API)
  // ============================================
  function initNavProductCounts() {
    var oilPanCount = 0;
    var wheelHubCount = 0;
    var camberCount = 0;
    var totalCount = 0;
    var page = 1;
    var keepGoing = true;

    function fetchPage() {
      fetch('/collections/all/products.json?limit=250&page=' + page)
        .then(function(res) { return res.json(); })
        .then(function(data) {
          var products = data.products || [];
          products.forEach(function(product) {
            var title = product.title || '';
            if (title.indexOf('Oil Pan') !== -1) oilPanCount++;
            if (title.indexOf('Wheel Hub') !== -1) wheelHubCount++;
            if (title.indexOf('Camber') !== -1) camberCount++;
          });
          totalCount += products.length;

          if (products.length === 250) {
            page++;
            fetchPage();
          } else {
            updateNavCounts();
          }
        })
        .catch(function() {
          updateNavCounts();
        });
    }

    function updateNavCounts() {
      var el1 = document.getElementById('navOilPanCount');
      var el2 = document.getElementById('navWheelHubCount');
      var el3 = document.getElementById('navCamberCount');
      var el4 = document.getElementById('navAllCount');
      if (el1) el1.textContent = '(' + oilPanCount + ')';
      if (el2) el2.textContent = '(' + wheelHubCount + ')';
      if (el3) el3.textContent = '(' + camberCount + ')';
      if (el4) el4.textContent = '(' + totalCount + ')';
    }

    fetchPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
